import { handleActions, createAction } from 'redux-actions';
import { api } from '../../../services';

const AGENCY_GET = 'AGENCY_GET';
const AGENCY_CREATE = 'AGENCY_CREATE';
const AGENCY_UPDATE = 'AGENCY_UPDATE';
const AGENCY_DELETE = 'AGENCY_DELETE';
const AGENCY_FEED_SECRET_GENERATE = 'AGENCY_FEED_SECRET_GENERATE';
const AGENCY_FEED_SECRET_REVOKE = 'AGENCY_FEED_SECRET_REVOKE';

export const getAgencies = createAction(
  AGENCY_GET,
  async (searchCriteria, page, itemPerPage, callback) => {
    try {
      const agencies = await api.Agency.list({
        ...searchCriteria,
        page,
        itemPerPage,
      });

      callback && callback();

      return {
        agencies: agencies.data,
        total: agencies.count,
        page,
        itemPerPage,
      };
    } catch (error) {
      callback && callback();

      return { agencies: [], total: 0, page: 1 };
    }
  },
);

export const createAgency = createAction(
  AGENCY_CREATE,
  async (data, callback) => {
    try {
      const result = await api.Agency.create(data);

      callback && callback(true);

      return result;
    } catch (error) {
      callback && callback(false);

      return null;
    }
  },
);

export const updateAgency = createAction(
  AGENCY_UPDATE,
  async (id, data, callback) => {
    try {
      const result = await api.Agency.update(id, data);

      callback && callback();

      return result;
    } catch (error) {
      callback && callback();

      return null;
    }
  },
);

export const deleteAgency = createAction(
  AGENCY_DELETE,
  async (id, callback) => {
    try {
      await api.Agency.delete(id);

      callback && callback();

      return {};
    } catch (error) {
      callback && callback();

      return null;
    }
  },
);

export const generateFeedSecret = createAction(
  AGENCY_FEED_SECRET_GENERATE,
  async (id, callback) => {
    try {
      const result = await api.Agency.generateFeedSecret(id);

      callback && callback(true);

      return result;
    } catch (error) {
      callback && callback(false);

      return null;
    }
  },
);

export const revokeFeedSecret = createAction(
  AGENCY_FEED_SECRET_REVOKE,
  async (id, callback) => {
    try {
      const result = await api.Agency.revokeFeedSecret(id);

      callback && callback(true);

      return result;
    } catch (error) {
      callback && callback(false);

      return null;
    }
  },
);

// Selectors
export const selectAll = state => state.admin.agency;

// Reducer
const initialState = {
  agencies: [],
  total: 0,
  page: 1,
  itemPerPage: 10,
  searchCriteria: {
    id: null,
    username: null,
    email: null,
  },
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload,
});

export default handleActions(
  {
    [AGENCY_GET]: updateState,
    [AGENCY_DELETE]: updateState,
  },
  initialState,
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAgencyPage/agency.ducks.ts